<template>
    <div class="container">
        <div class="m-portlet">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        Neuer Angebotsvorlagen Text
                    </h3>
                </div>
            </div>
        </div>

        <!--begin::Form-->
            <div class="m-portlet__body">
                <el-form :rules="rules" ref="offerTemplatePart" :model="offerTemplatePart" label-width="200px">
                    <el-form-item prop="type_id" label="Kategorie">
                        <el-select  v-model="offerTemplatePart.type_id" placeholder="Bitte wählen">
                            <el-option
                                v-for="(item, key) in partTypes"
                                :key="key"
                                :label="item"
                                :value="key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Name" prop="name">
                        <el-input v-model="offerTemplatePart.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Überschrift">
                        <el-input v-model="offerTemplatePart.headline"></el-input>
                    </el-form-item>
                    <el-form-item prop="template" label="Beschreibung" v-if="offerTemplatePart.type_id != 5">
                        <el-input type="textarea" v-model="offerTemplatePart.template" class="w-100" rows="15"></el-input>
                    </el-form-item>
                    <el-form-item label="Beschreibung in kurz">
                        <el-input type="textarea" v-model="offerTemplatePart.template_short" class="w-100" rows="10"></el-input>
                    </el-form-item>
                    <div v-if="offerTemplatePart.type_id == 5">
                        <el-form-item label="Preis Spalten">
                            <el-input v-model="priceArr.priceCols"></el-input>
                        </el-form-item>
                        <h4 class="mt-3">Preisabstufungen</h4>
                        <div class="row">
                            <div class="col-4">
                                <el-form-item label="Preis 1 in %">
                                    <el-input-number size="mini" v-model="priceArr.price1"></el-input-number>
                                </el-form-item>
                            </div>
                            <div class="col-4" v-if="priceArr.priceCols == 2 || priceArr.priceCols == 3">
                                <el-form-item label="Preis 2 in %">
                                    <el-input-number size="mini" v-model="priceArr.price2"></el-input-number>
                                </el-form-item>
                            </div>
                            <div class="col-4" v-if="priceArr.priceCols == 3">
                                <el-form-item label="Preis 3 in %">
                                    <el-input-number size="mini" v-model="priceArr.price3"></el-input-number>
                                </el-form-item>
                            </div>
                        </div>
                        <h4 class="mt-3">Preismatrix</h4>
                        <offer-template-part-text v-for="(text, key) in priceArr.texts" :key="'texts-' + key" :text="text" :price-cols="priceArr.priceCols"></offer-template-part-text>
                        <div class="text-right mt-4">
                            <el-button @click="addTextCol()">neue Zeile</el-button>
                        </div>
                    </div>
                    <div class="mt-4"><el-button type="success" @click="submitForm('offerTemplatePart')">Speichern</el-button></div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import OfferTemplatePartAPI from "~/api/offerTemplatePart";
import OfferTemplatePart from "./offer-template/OfferTemplatePart";
import OfferTemplatePartText from "./offer-template/OfferTemplatePartText";

    export default{
        components: {
            OfferTemplatePart,
            OfferTemplatePartText
        },
        props: {
            partTypes: Object,
        },
        data() {
            return {
                offerTemplatePart:{
                    type_id: null,
                    name: null,
                    template: null,
                    template_short: null,
                    headline: null
                },
                priceArr: {
                    priceCols: 3,
                    price1: 100,
                    price2: 110,
                    price3: 130,
                    texts:[]
                },
                rules: {
                    name: [
                        { required: true, message: 'Bitte Namen ein geben', trigger: 'blur' },
                    ],
                    template: [
                        { required: true, message: 'Bitte Beschreibungstext eingeben', trigger: 'blur' },
                    ],
                    type_id: [
                        { required: true, message: 'Bitte Typ auswählen', trigger: 'blur' },
                    ]
                }
            }
        },
        methods:{
            addTextCol(){
                this.priceArr.texts.push({
                    name: "",
                    price1: "",
                    price2: "",
                    price3: "",
                });
            },
            submitForm(formName) {
                let that = this;

                if (that.offerTemplatePart.type_id == 5){
                    that.offerTemplatePart.template = that.priceArr;
                    console.log("x");
                }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        OfferTemplatePartAPI.postAddNewOfferTemplatePart({
                            offerTemplatePart: that.offerTemplatePart,
                        }).then(function (response) {
                            window.location.href = "/angebots-vorlagen-texte/" + response.data;
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>
